import { Button, Checkbox, ComboBox, IColumn, IDataView, Modal, Tables } from '@ixyberfree/ixybercomponents';

import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import { IComboBoxData } from 'components/modules/trends/GroupTrend/ComboBox/ComboBox';
import React, { useEffect } from 'react';
import { colorText, ContentPopup, CustomTooltip, CustomTooltipContainer, CustomTooltipTrigger, MainText } from 'styles';

interface IPropsExportWindow {
    closeCM?: Function;
    createCB?: Function;
    pid?: string;
}

export const ExportWindow: React.FC<IPropsExportWindow> = ({ closeCM, createCB, pid }) => {
    const forbiddenChars = ['.', '/', '\\', '$', '_', ' '];
    const excludedKeys = ['name', 'shape', 'ClassName', 'path', 'Key', 'Value'];
    const defaultComboBoxVariants: IComboBoxData[] = [
        { id: '0', value: ';' },
        { id: '1', value: ',' },
        { id: '2', value: ':' }
    ];

    const [dataFromServer, setDataFromServer] = React.useState<any>(null);
    const [separator, setSeparator] = React.useState<string>(';');
    const [checkedProperties, setCheckedProperties] = React.useState<any[]>([]);
    const [checkedTypes, setCheckedTypes] = React.useState<any[]>([]);
    const [typeNames, setTypeNames] = React.useState<any[]>([]);
    const [propertyNames, setPropertyNames] = React.useState<any[]>([]);
    const [propertiesToSend, setPropertiesToSend] = React.useState<any[]>([]);
    const [typesToSend, setTypesToSend] = React.useState<any[]>([]);
    const [isVisible, setIsVisible] = React.useState<boolean>(false);
    const [isExportAll, setIsExportAll] = React.useState<boolean>(false);
    const [isInvalidValue, setIsInvalidValue] = React.useState<boolean>(false);
    const [selected, isSelected] = React.useState<IDataView>(defaultComboBoxVariants[0]);
    const [comboBoxDataVariants, setComboBoxDataVariants] = React.useState<IComboBoxData[]>(defaultComboBoxVariants);

    useEffect(() => {
        hmiclientbase.SettingsGetTypesWithProperties(pid).then((obj: any) => {
            setDataFromServer(obj);
            const namesWithProperties = Object.entries(obj);
            const names: string[] = [];
            namesWithProperties.map(([key, _]) => names.push(key));
            setTypeNames(names);
        });
    }, []);

    useEffect(() => {
        setCheckedTypes(['0']);
        setTypesToSend([typeNames[0]]);
        if (typeNames.length > 0) setPropertyNames(filterProperties(typeNames[0]));
    }, [typeNames]);

    const typeNamesArr: any[] = [];
    const propertyNamesArr: any[] = [];

    const headerProperties: IColumn[] = [
        {
            type: 'select',
            width: '',
            label: 'selected',
            idCol: 'select',
            action: true
        },
        {
            type: 'text',
            width: '100%',
            label: 'Название поля',
            idCol: 'label',
            action: true
        }
    ];

    const headerTypes: IColumn[] = [
        {
            type: 'select',
            width: '',
            label: 'selected',
            idCol: 'select',
            action: true
        },
        {
            type: 'text',
            width: '100%',
            label: 'Название типа',
            idCol: 'label',
            action: true
        }
    ];

    const handleInvalidValue = (e: IComboBoxData) => {
        setIsInvalidValue(false);
        isSelected({ id: e.id, value: e.value });
        setSeparator(e.value);
    };

    const handleInputValue = (e: IComboBoxData) => {
        if (forbiddenChars.some((char) => e.value.includes(char)) || e.value.length > 1 || e.value.length == 0) {
            setIsInvalidValue(true);
        } else {
            setIsInvalidValue(false);
            let tempComboBox: IComboBoxData[] = [...comboBoxDataVariants];
            let itemToUpdate = tempComboBox.find((item) => item.id === '3');
            if (itemToUpdate) {
                itemToUpdate.value = e.value;
                isSelected({ id: itemToUpdate.id, value: itemToUpdate.value });
                setSeparator(itemToUpdate.value);
                setComboBoxDataVariants(tempComboBox);
            } else {
                tempComboBox.push({ id: '3', value: e.value });
                isSelected({ id: '3', value: e.value });
                setSeparator(e.value);
                setComboBoxDataVariants(tempComboBox);
            }
        }
    };

    function handleSelectProperties(item: any, check: boolean) {
        const newCheckedProperties = check
            ? [...checkedProperties, item.id]
            : checkedProperties.filter((i) => i !== item.id);
        const newPropertiesToSend = check
            ? [...propertiesToSend, item.label]
            : propertiesToSend.filter((i) => i !== item.label);

        setCheckedProperties(newCheckedProperties);
        setPropertiesToSend(newPropertiesToSend);
    }

    function handleSelectAllProperties(check: boolean, items: string[]) {
        const newCheckedProperties = check ? items : [];
        const newPropertiesToSend = check ? propertyNamesArr.map((i) => i.label) : [];

        setCheckedProperties(newCheckedProperties);
        setPropertiesToSend(newPropertiesToSend);
    }

    function handleSelectTypes(item: any, check: boolean) {
        const newCheckedTypes = check ? [...checkedTypes, item.id] : checkedTypes.filter((i) => i !== item.id);
        const newTypesToSend = check ? [...typesToSend, item.label] : typesToSend.filter((i) => i !== item.label);

        if (check == false) {
            const filter = findUniqueProperties(item);

            setPropertyNames((prevState) => {
                const updatedPropertyNames = prevState.filter((propertyName) => !filter.includes(propertyName));
                return updatedPropertyNames;
            });
            setPropertiesToSend([]);
            setCheckedProperties([]);
        } else {
            setPropertyNames(filterProperties(item.label));
            setPropertiesToSend([]);
            setCheckedProperties([]);
        }

        setCheckedTypes(newCheckedTypes);
        setTypesToSend(newTypesToSend);
    }

    function handleSelectAllTypes(check: boolean, items: string[]) {
        const newCheckedTypes = check ? items : [];
        const newTypesToSend = check ? typeNamesArr.map((i) => i.label) : [];

        if (check == false) {
            setPropertiesToSend([]);
            setPropertyNames([]);
        } else {
            typeNames.forEach((item) => {
                setPropertyNames((prevState) => {
                    const newProperties = filterProperties(item);
                    const combined = [...prevState, ...newProperties];
                    const unique = [...new Set(combined)];
                    return unique;
                });
            });
            setPropertiesToSend([]);
            setCheckedProperties([]);
        }

        setCheckedTypes(newCheckedTypes);
        setTypesToSend(newTypesToSend);
    }

    function filterProperties(type: string) {
        const filteredTypes = Object.entries(dataFromServer)
            .filter(([key]) => key.includes(type))
            .flat();
        const namesWithType = Object.entries(filteredTypes[1] as { [key: string]: unknown });

        const filteredKeys = namesWithType
            .filter(
                ([key, value]) =>
                    ((value as string).includes('String') &&
                        !key.toLowerCase().includes('id') &&
                        !excludedKeys.includes(key) &&
                        !(value as string).includes('Dictionary') &&
                        !(value as string).includes('HashSet')) ||
                    key.includes('IdTemplate') ||
                    key.includes('CV')
            )
            .map(([key]): string => key);

        const currentPropertyNames = [...propertyNames];
        const combinedPropertyNames = [...currentPropertyNames, ...filteredKeys];
        const uniquePropertyNames = [...new Set(combinedPropertyNames)];

        return uniquePropertyNames;
    }

    function findUniqueProperties(item: any) {
        const data = Object.entries(dataFromServer);
        const typesToFilter = checkedTypes.map((index) => typeNames[parseInt(index)]);
        const checkedTypesArr = data.filter((obj) => typesToFilter.includes(obj[0]));
        const itemPropertiesWithTypes: any = checkedTypesArr.filter((obj) => obj[0] === item.label).flat()[1];
        const itemProperties = Object.keys(itemPropertiesWithTypes);

        const allKeys = checkedTypesArr.flatMap((obj: any) => Object.keys(obj[1]));
        const repeatedKeys = allKeys.filter((key, index, self) => {
            return self.indexOf(key) !== index;
        });

        const filteredKeys = itemProperties.filter((key) => !repeatedKeys.includes(key));
        return filteredKeys;
    }

    for (let i = 0; i < typeNames.length; i++) {
        const obj = { label: `${typeNames[i]}` };
        typeNamesArr.push(obj);
    }

    for (let i = 0; i < propertyNames.length; i++) {
        const obj = { label: `${propertyNames[i]}` };
        propertyNamesArr.push(obj);
    }

    return (
        <Modal
            className="modal-window"
            headerLabel="Экспорт"
            width="20rem"
            onCloseClick={() => {
                closeCM && closeCM();
            }}>
            <ContentPopup
                style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}
                onClick={(e) => e.stopPropagation()}>
                <Tables
                    header={headerTypes}
                    data={typeNamesArr}
                    allChecked={true}
                    onAllCheck={handleSelectAllTypes}
                    onCheck={handleSelectTypes}
                    checked={checkedTypes}
                    height="250px"
                />
                <Tables
                    header={headerProperties}
                    data={propertyNamesArr}
                    allChecked={true}
                    onAllCheck={handleSelectAllProperties}
                    onCheck={handleSelectProperties}
                    checked={checkedProperties}
                    height="250px"
                />
                <MainText size={14} color={colorText.main}>
                    <div
                        style={{
                            marginBottom: '5px',
                            display: 'flex',
                            color: '#333',
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: '300',
                            lineHeight: '18px'
                        }}>
                        Разделитель
                        <CustomTooltipContainer>
                            <CustomTooltipTrigger
                                style={{ marginLeft: '3px' }}
                                onMouseEnter={() => setIsVisible(true)}
                                onMouseLeave={() => setIsVisible(false)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none">
                                    <path
                                        d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z"
                                        fill="#66c3d0"
                                        style={{ fill: isVisible ? '#66c3d0' : '#AEAEAE' }}
                                    />
                                    <path
                                        d="M6.5224 6.77414C6.43343 7.05082 6.21378 7.29109 5.92314 7.29109C5.6275 7.29109 5.38055 7.04813 5.42509 6.75587C5.43087 6.71791 5.4373 6.68128 5.44436 6.64597C5.4832 6.46284 5.54841 6.29775 5.63997 6.15069C5.73431 6.00363 5.85917 5.85796 6.01456 5.71368C6.14497 5.59714 6.25873 5.48615 6.35584 5.38071C6.45296 5.27528 6.52926 5.16706 6.58475 5.05608C6.64025 4.94231 6.668 4.81606 6.668 4.67733C6.668 4.5164 6.64302 4.38321 6.59308 4.27777C6.54591 4.16956 6.47377 4.08771 6.37665 4.03221C6.28231 3.97672 6.163 3.94897 6.01872 3.94897C5.89941 3.94897 5.78842 3.97533 5.68575 4.02805C5.58309 4.07799 5.49846 4.15569 5.43187 4.26112C5.30747 4.46665 5.13925 4.67733 4.89901 4.67733H4.73996C4.40252 4.67733 4.11471 4.39223 4.2228 4.07257C4.26441 3.94951 4.31921 3.83756 4.3872 3.73671C4.55645 3.48698 4.78259 3.30247 5.06561 3.18316C5.34863 3.06107 5.66633 3.00003 6.01872 3.00003C6.40717 3.00003 6.74014 3.06384 7.01761 3.19148C7.29508 3.31634 7.50734 3.50086 7.6544 3.74503C7.80146 3.98643 7.87499 4.28055 7.87499 4.62738C7.87499 4.86878 7.82782 5.08382 7.73348 5.2725C7.63914 5.45841 7.51567 5.63182 7.36306 5.79276C7.21045 5.95369 7.04258 6.12017 6.85945 6.2922C6.70129 6.43371 6.59308 6.58216 6.53481 6.73754C6.53052 6.74956 6.52638 6.76176 6.5224 6.77414ZM5.26123 8.57716C5.26123 8.39958 5.32227 8.25252 5.44436 8.13599C5.56644 8.01667 5.73015 7.95702 5.93548 7.95702C6.13803 7.95702 6.30035 8.01667 6.42244 8.13599C6.5473 8.25252 6.60973 8.39958 6.60973 8.57716C6.60973 8.74919 6.5473 8.89487 6.42244 9.01418C6.30035 9.13349 6.13803 9.19314 5.93548 9.19314C5.73015 9.19314 5.56644 9.13349 5.44436 9.01418C5.32227 8.89487 5.26123 8.74919 5.26123 8.57716Z"
                                        fill="white"
                                    />
                                </svg>
                            </CustomTooltipTrigger>
                            <CustomTooltip isVisible={isVisible}>
                                Нельзя использовать системные разделители:
                                <br />
                                <b>. / \ $ _ пробел</b>
                            </CustomTooltip>
                        </CustomTooltipContainer>
                    </div>
                </MainText>
                <ComboBox
                    type="text"
                    data={comboBoxDataVariants}
                    selected={selected}
                    width="100%"
                    isInvalid={isInvalidValue}
                    onElementClick={(event) => {
                        const item = event.target as HTMLElement;
                        const itemId = item.getAttribute('itemId');
                        if (itemId) {
                            const selectedObj = { id: itemId, value: item.innerHTML };
                            handleInvalidValue(selectedObj);
                        }
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            const inputItem = event.target as HTMLInputElement;
                            const selectedObj = { id: '', value: inputItem.value };
                            handleInputValue(selectedObj);
                        }
                    }}
                />
                <div style={{ marginTop: '20px' }}>
                    <Checkbox
                        checked={isExportAll}
                        label="Экспортировать вместе с содержимым?"
                        width="100%"
                        onClick={() => setIsExportAll(!isExportAll)}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-around', paddingTop: '20px' }}>
                    <Button
                        text="Экспортировать"
                        disabled={isInvalidValue}
                        // disabled
                        size="small"
                        styleType="filled"
                        onClick={() => {
                            createCB && createCB(pid, separator, propertiesToSend, typesToSend, isExportAll);
                        }}
                    />
                    <div style={{ width: '1.8em' }}></div>
                    <Button text="Отменить" styleType="tinted" size="small" onClick={() => closeCM && closeCM()} />
                </div>
            </ContentPopup>
        </Modal>
    );
};
